import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconUnmute({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `edu-icon edu-icon--${size} ${className}`;
  return <>{!!srText && <span className='sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" aria-hidden="true" role="img" className={newClassName} {...props}><g fill="currentColor"><path d="m9.938 17.238-5.397-3.895H-.091V6.657H4.54l5.397-3.895zM20.091 12.719 18.91 13.9l-6.742-6.742 1.182-1.182z" /><path d="m13.35 14.024-1.183-1.183L18.91 6.1l1.182 1.182z" /></g></svg></>;
}
export default IconUnmute;